module.exports = __webpack_public_path__ + "img/1.352d9dde.jpg";